import Surveys from "./Surveys";

export default Surveys;
